import { LeftOutlined } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import "./RegStepPayment.scss";
import { paymentJsLoadedState, planLengthState, planTypeState } from "../../state/atoms";
import DashboardApi from "../../api/DashboardApi";
import { Spinner } from "../account/misc/Spinner";
import { useRecoilValue } from "recoil";
import StepCounter from "../StepCounter";
import CancelRegistrationLink from "./CancelRegistrationLink";
import Storage from '../../util/Storage';

interface RegStepPaymentProps {
  onNext: () => void;
  onBack?: () => void;
  onCancelRegistration: () => void;
  regStep: number;
  regStepTotal: number;
}

export default function RegStepPayment({ onNext, onBack, onCancelRegistration, regStep, regStepTotal }: RegStepPaymentProps) {
  const divRef = useRef<HTMLDivElement>(null);
  const paymentJsLoaded = useRecoilValue(paymentJsLoadedState);
  const planType = useRecoilValue(planTypeState);
  const planLength = useRecoilValue(planLengthState);
  const [memberId, setMemberId] = useState('');
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);

  const onNextRef = useRef(onNext);
  onNextRef.current = onNext;

  useEffect(() => {
    DashboardApi.status().then((resp) => {
      const {member} = resp.data;
      setMemberId(member?.id ?? '');
      setLoading(false);
    }).catch(() => {
      Storage.removeRegisterFlag();
      window.location.href = '/account/register';
    });
  }, []);

  useEffect(() => {
    if (!divRef.current || !paymentJsLoaded || !memberId || !planType) return;

    window.MHM.ProModal.upgradeInline({
      memberId: memberId,
      onSuccess: () => onNextRef.current(),
      onProcessingChange: setProcessing,
      container: divRef.current,
      planType: planType,
      planLength: planLength
    });

    return () => {
      window.MHM.ProModal.destroy();
    }
  }, [paymentJsLoaded, planType, planLength, memberId]);
  return loading ? <div className={'spinner'}><Spinner/></div> : <div className={"step-type step full payment standalone-payment-wrapper"}>
    {onBack && <div className={`back ${processing ? "disabled" : ""}`} onClick={processing ? undefined : onBack}><LeftOutlined /></div>}
    <StepCounter total={regStepTotal} current={regStep}/>
    <div className={`payment-cancel-link ${processing ? "disabled" : ""}`}><CancelRegistrationLink onCancel={onCancelRegistration} /></div>
    <div ref={divRef}></div>
  </div>;
}
